import React from "react";
import c_logo1 from "../../Images/c_logo1.png";
import c_logo2 from "../../Images/c_logo2.png";
import c_logo3 from "../../Images/hotels_logo.png";
// import c_logo4 from "../../Images/c_logo4.png";
// import c_logo5 from "../../Images/c_logo5.png";

import "./Cdetails.css";
function Cdetails() {
  let imgHeight;
  if (window.innerWidth >= 300 && window.innerWidth <= 800) {
    imgHeight = "2rem";
  } else {
    imgHeight = "3rem";
  }
  return (
    <div className="Cdetails">
      <div className="map">
        <iframe
          className="frame1"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3677.085246971437!2d86.04917669999999!3d22.8363354!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f5ef0042212ea9%3A0xb68ccbadf3676fee!2sFour%20Seasons%20Resort!5e0!3m2!1sen!2sin!4v1732882835341!5m2!1sen!2sin"
          width="400"
          height="360"
          //   style={{ border: "10px" }}
          allowFullScreen=""
          loading="lazy"
          title="four seasons resort location Kandra Jamshedpur"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
      <div className="contact-details">
        {/* <p className="p1">Write us some message</p>
        <input type="text" placeholder="Email" className="input1" />
        <input
          type="text"
          placeholder="Message"
          className="input2"
        /> <br /> <br />
        <button className="c-btn" style={{ backgroundColor: "red" }}>
          <p className="c-btn-text">Submit</p>
        </button> */}
        <p className="company-logo-container">Book Your Reservation Today! </p>
        <div className="c_logo">
          <a
            href="https://www.booking.com/Share-zM1X7xw"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={c_logo1} alt="logo1" style={{ height: imgHeight }} />
          </a>
          <a
            href="https://expe.app.link/37I5hxTVrNb"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={c_logo2} alt="logo2" style={{ height: imgHeight }} />
          </a>
          <a
            href="https://hotels.app.link/N85GvXPVrNb"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={c_logo3} alt="logo3" style={{ height: imgHeight }} />
          </a>
        </div>
      </div>
    </div>
  );
}

export default Cdetails;
